import styled from "styled-components";

export const PointHistoryList = styled.ul`
  width: 100%;
  display: flex;
  overflow-y: auto;
  align-items: center;
  flex-direction: column;

  li + li {
    border-top: 1px solid ${(props) => props.theme.colors.black5};
  }
`;
